import VipMedallion from "@/components/vip/VipMedallion";
import { VIP_BY_TIER } from "@/lib/vipTiers";

// Monthly supporter badge (server-calculated current-month tier only) — medallion + tier chip beside the preferred name.
export default function VipBadge({ tier, size = "sm", className = "" }) {
  const s = VIP_BY_TIER[tier];
  if (!s) return null;
  const dim = size === "xs" ? "text-[10px] px-1.5 py-0.5 gap-1" : "text-xs px-2 py-0.5 gap-1.5";
  return (
    <span data-testid={`vip-badge-${tier}`} title={`${s.label} · this month`} className={`inline-flex items-center border uppercase tracking-widest font-medium ${dim} ${s.text} ${s.border} bg-black/40 ${className}`}>
      <VipMedallion tier={tier} size="xs" className={size === "xs" ? "!w-4 !h-4" : "!w-5 !h-5"} /> {s.label}
    </span>
  );
}
